import { useState, useEffect } from "react";
import Images from "../../constant/images";
import "../login/login.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import {
  localStorageKey,
  screenPath,
  toastStatus,
} from "../../constant/strings";
import ToastMessage, { showToast } from "../../components/ToastMessage";
import { loginApi } from "../../services/apiCall";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const navigation = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userType = queryParams.get("type");

  const validate = () => {
    const newErrors = {};
    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();

    if (!trimmedEmail) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(trimmedEmail)) {
      newErrors.email = "Enter a valid email";
    }

    if (!trimmedPassword) {
      newErrors.password = "Password is required";
    } else if (trimmedPassword.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (localStorage.getItem(localStorageKey.authToken)) {
      if (userType === "accountant") {
        navigation(screenPath.dashboardPage);
      } else if (userType === "company") {
        navigation(screenPath.dashboardCompanyPage);
      } else if (userType === "admin") {
        navigation(screenPath.adminDashboard);
      }
    }
  }, [navigation, userType]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      if (
        userType === "admin" &&
        email === "admin@gmail.com" &&
        password === "123456"
      ) {
        localStorage.setItem(localStorageKey.authToken, "admin-mock-token");
        localStorage.setItem(localStorageKey.userType, "admin");
        showToast("Admin login successful", toastStatus.success, () => {
          navigation(screenPath.adminDashboard);
        });
        return;
      }

      const payload = { email, password };
      console.log("payload from login:::", payload);
      const res = await loginApi(payload);
      console.log("res from login:::", res);
      if (res?.data?.token) {
        localStorage.setItem(localStorageKey.authToken, res?.data?.token);
        localStorage.setItem(localStorageKey.userType, userType);
        showToast(`Login successful for ${email}`, toastStatus.success, () => {
          navigation(screenPath.accountantSelectCompany);
        });
      } else {
        showToast(`Login failed for ${email}`, toastStatus.error);
      }
    } catch (error) {
      console.log("error from login api::::::", error);
      showToast(`Login failed for ${email}`, toastStatus.error);
    }
  };

  return (
    <div className="login-container">
      <ToastMessage />
      <div className="login-left">
        <img src={Images.logo} alt="Logo" className="login-logo" />
      </div>

      <div className="login-right">
        <h2>Login</h2>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email ID</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              aria-describedby={errors.email ? "email-error" : undefined}
            />
            {errors.email && (
              <p id="email-error" className="error-text" role="alert">
                {errors.email}
              </p>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="password-input-container">
              <div className="password-field">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <FaEye size={20} />
                  ) : (
                    <FaEyeSlash size={20} />
                  )}
                </button>
              </div>
            </div>
            {errors.password && (
              <p id="password-error" className="error-text" role="alert">
                {errors.password}
              </p>
            )}
          </div>

          <button type="submit" className="login-btn">
            Login
          </button>

          {/* <p className="signup-text">
            Don’t have an account?{" "}
            <Button
              className="signup-btn"
              variant="text"
              onClick={handleSignup}
            >
              Sign Up
            </Button>
          </p> */}
        </form>
      </div>
    </div>
  );
};

export default Login;
